import { render, staticRenderFns } from "./update.vue?vue&type=template&id=2548bd2a&scoped=true&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./update.vue?vue&type=style&index=1&id=2548bd2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548bd2a",
  null
  
)

export default component.exports